import { ActionTree } from 'vuex';
import { parseCarriersData } from '@/features/shipment/services/shipment.services';
import { AvailableService, GetRatesData } from '@/features/shipment/types';
import { deepClone, showErrorAlertDialog } from '@/features/common/helpers';
import { defaultEstimateData } from '@/features/common/raw';
import moment from 'moment';
import { EstimateStateType } from '../types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const actions: ActionTree<EstimateStateType, any> = {
  async getNewEstimateRates({ state, commit }, payload) {
    const { date, showLoading } = payload || {};

    let shipDateTime = moment().format('YYYY-MM-DD');

    if (date) {
      shipDateTime = moment(date).format('YYYY-MM-DD');
    }

    commit('patchInProgress', { key: 'shipDate', value: shipDateTime });

    const data: GetRatesData = {
      currencyCode: 'CAD',
      fromAddress: {
        ...state.estimateData.fromAddress,
        city: state.estimateData.fromAddress.city || '',
        addr1: state.estimateData.fromAddress.addr1 || '',
      },
      toAddress: {
        ...state.estimateData.toAddress,
        city: state.estimateData.toAddress.city || '',
        addr1: state.estimateData.toAddress.addr1 || '',
      },
      packages: state.estimateData.packages,
      shipDateTime,
      documentsOnly: state.estimateData.isDocumentsOnly,
    };

    if (showLoading !== false) {
      commit('setLoading', true);
    }

    commit('setReconnectAccountRequired', null);
    const ratesResponse = await parseCarriersData(data, 'Rates');

    if (ratesResponse) {
      const { rates, reconnectAccounts } = ratesResponse;
      const services = rates.map((el: AvailableService, idx: number) => {
        const copy = el;
        copy.show = true;
        copy.id = idx + 1;
        return copy;
      });
      commit('setAvailableServices', services);
      commit('setReconnectAccountRequired', reconnectAccounts);
    } else {
      commit('setReconnectAccountRequired', null);
      showErrorAlertDialog();
    }

    if (showLoading !== false) {
      commit('setLoading', false);
    }
  },

  clearEstimateDataInShortly({ commit }) {
    setTimeout(() => {
      commit('setEstimateData', deepClone(defaultEstimateData));
    }, 500);
  },
};

export default actions;
